import { mapActions, mapGetters, mapState } from 'vuex';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import loaderMixin from '@/mixins/loader';
import Contract from '@/models/contract';
import marketContractInfoV2, { MARKET_CONTRACT_INFO_VALUES_LAYOUT } from '@/components/market/v2/market-contract-info-v2/market-contract-info-v2.vue';
import marketWinnerV2 from '@/components/market/v2/market-winner-v2/market-winner-v2.vue';


const MAX_CONTRACTS_NUM = 10;


export default {
  mixins: [
    loaderMixin,
  ],
  props: {
    type: {
      type: String,
      default: 'standalone'
    }
  },
  components: {
    marketChangePrice,
    marketContractInfoV2,
    marketWinnerV2,
  },
  data() {
    return {
      ready: false,
      MARKET_CONTRACT_INFO_VALUES_LAYOUT,
    }
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    ...mapState('market', ['market', 'relatedProducts', 'reloadHistoryToggle']),
    classModifiers() {
      return {
        'product-history-sushi': true,
        [`product-history-sushi--${this.type}`]: this.type
      }
    },
  },
  watch: {
    market: {
      handler: 'marketHandler',
      immediate: true
    },
    reloadHistoryToggle(val) {
      this.reloadHistory();
    }
  },
  methods: {
    ...mapActions('market', ['getRelatedProducts']),
    itemLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query: { contractId: item.id }
      }
    },
    getContracts (item) {
      if (item.contractWinner) {
        return [item.contractWinner].map(i => new Contract(i))
      }
      return (item.contracts || []).slice(0, 2).map(i => new Contract(i))
    },
    contractName(item) {
      if (item.marketType !== 0) {
        return item.contractName;
      }
      const type = item.tradeType;
      return (type === 0 || type === 2) ? 'No' : 'Yes';
    },
    marketHandler(value) {
      if (value) {
        this.loaderAdd(document.body);
        this.getRelatedProducts(this.market.marketId)
          .then(() => {
            this.ready = true;
            this.loaderRemove(document.body)
          })
          .catch(() => {
            this.ready = true;
            this.loaderRemove(document.body);
          });
      }
    },
    reloadHistory() {
      this.loaderAdd(document.body);
      this.getRelatedProducts(this.market.marketId)
        .then(() => {
          this.ready = true;
          this.loaderRemove(document.body)
        })
        .catch(() => {
          this.ready = true;
          this.loaderRemove(document.body);
        });
    },
    imageStyleModifiers (item) {
      return {
        'background-image': `url('${item.marketImageUrl}')`,
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/product-history-sushi/product-history-sushi.js